import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppSessionService } from "../app-session/app-session.service";

@Injectable({
  providedIn: "root",
})
export class PosService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  createPos(pos: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(pos);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/pos"}`;
    return this.http.post(url, data, { headers });
  }

  updatePos(pos: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(pos);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/pos"}/${
      pos?.code
    }`;
    return this.http.put(url, data, { headers });
  }
}
